export default "/_next/static/assets/DunbarTall-Book_874978435925454d71b434d150e80064.woff2";